/**
 * index  轨迹查询
 *
 * @Author  Carey.zhou
 * @DATE    create on 2019/9/16
 * @DESC
 */
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const state = {
  queryParam: {
    vno: '',
    startDate: '', // 选择的开始时间, 开始时间和结束时间相差不能大于 24 小时,开始时间必须在半年以内
    endDate: '' //选择的结束时间, 必须选择完开始时间,才可以选择结束时间
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}




